import React from "react";
import {Outlet} from "react-router-dom";
import {AppLayout} from "../AppLayout";
import {BaseFilterPanel} from "../panels/BaseFilterPanel";
import {useRouterParamsStoreSync} from "../../store/routerStore";
import {useCompanyIdPersist} from "../../hooks/companyIdPersistHooks";
import {BaseContextPanel} from "../panels/BaseContextPanel";

export const MapPage: React.FC = () => {
    useRouterParamsStoreSync();
    useCompanyIdPersist();

    return (
        <AppLayout sidePanel={<BaseFilterPanel basePath="map" />} rightPanel={<BaseContextPanel />}>
            <Outlet />
        </AppLayout>
    );
};
